import React, { useEffect, useState } from "react";
import { Circle, GoogleMap } from "@react-google-maps/api";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";

const containerStyle = {
  width: "100%",
  height: "17rem",
};



const AppHeatMapComponent = () => {
  const [heatmapData, setHeatmapData] = useState<google.maps.LatLngLiteral[]>([]);
  const [center, setCenter] = useState<{ lat: number; lng: number } | undefined>(undefined);

  useEffect(() => {
    ZyppLiteApi.api.googleMapsOnDutyRiders().then((response) => {
      const vehicles = response.data.vehicles || [];
  
      const points = vehicles
        .filter((e:any) => e.latitude && e.longitude)
        .map((e:any) => {
          const lat = parseFloat(e.latitude.toString());
          const lng = parseFloat(e.longitude.toString());
          return { lat, lng };
        });
  
      setHeatmapData(points);
  
      if (points.length > 0) {
        setCenter({
          lat: points[0].lat,
          lng: points[0].lng,
        });
      }
    });
  }, []);
 
  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      zoom={9}
      center={center || { lat: 28.6139, lng: 77.2090 }} // fallback center (Delhi)
      options={{ fullscreenControl: true, zoomControl: true }}
    >
      {heatmapData.map((point, index) => (
        <React.Fragment key={`${point.lat}-${point.lng}-${index}`}>
          <Circle
            center={point}
            radius={900}
            options={{
              fillColor: "#e81414",
              fillOpacity: 0.14,
              strokeOpacity: 0,
              clickable: false,
              zIndex: 1,
            }}
          />
          <Circle
            center={point}
            radius={360}
            options={{
              fillColor: "#e81414",
              fillOpacity: 0.3,
              strokeOpacity: 0,
              clickable: false,
              zIndex: 2,
            }}
          />
        </React.Fragment>
      ))}
    </GoogleMap>
  );
};

export const AppHeatMap = React.memo(AppHeatMapComponent);
